class Feedback {

	show() {
		TweenLite.to(document.querySelector('.floating-feedback-box'), .5, {
			yPercent:    0,
			ease: Back.easeOut.config(1)
		});

	}

	hide() {
        TweenLite.to(document.querySelector('.floating-feedback-box'), .5, {
			yPercent: 100,
			ease: Sine.easeIn
		});
    }
}